import React, { type ComponentType } from 'react';

import clsx from 'clsx';
import IconAdd from '@/assets/icons/icon-add.svg?react';

interface SectionFieldProps {
  text: string;
  className: string;
  imageSrc?: string;
  onClick?: () => void;
  icon?: ComponentType<React.SVGProps<SVGSVGElement>>;
  showBlock?: boolean;
  blockBgColor?: string;
  blockTextStyles?: React.CSSProperties;
  'data-qa-selector'?: string;
}

export const SectionField: React.FC<SectionFieldProps> = ({
  className,
  text,
  imageSrc,
  onClick,
  icon: Icon = IconAdd,
  showBlock = false,
  blockBgColor = '#E5E7EB',
  blockTextStyles = {},
  'data-qa-selector': dataQaSelector,
}) => {
  return (
    <div
      onClick={onClick}
      data-qa-selector={dataQaSelector}
      className={clsx(
        'group hover:outline-neutral-10 flex h-12 w-56 cursor-pointer items-center justify-between gap-2 rounded-lg p-2 text-neutral-500 outline outline-offset-[-1px] outline-transparent transition-all hover:bg-indigo-100',
        className,
      )}
    >
      <div className="flex items-center gap-2">
        {showBlock ? (
          <div
            className="relative flex h-8 w-8 items-center justify-center rounded-md transition-all group-hover:shadow-[0px_2px_6px_0px_rgba(84,66,238,0.40)]"
            style={{ backgroundColor: blockBgColor }}
          >
            <span className="text-[100%]" style={blockTextStyles}>
              Aa
            </span>
          </div>
        ) : (
          imageSrc && (
            <img
              className="relative h-8 w-8 rounded-md transition-all group-hover:shadow-[0px_2px_6px_0px_rgba(84,66,238,0.40)]"
              src={imageSrc}
              alt="icon"
            />
          )
        )}
        <span className="text-button-sm">{text}</span>
      </div>
      {Icon && <Icon className="h-4 w-4" />}
    </div>
  );
};
